/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import StringResources from 'nls/StringResources';

/**
 * Models the 'compare' action a user can take on two single-vis cards,
 * creating a new compare card from their visualization
 */
class CompareAction {
	constructor(options) {
		this.exploreVM = options.exploreVM;
		this.layoutModel = options.layoutModel;
	}

	getAttributes() {
		return {
			id: 'compare',
			//no icon yet - need to add one if this action is to appear in the toolbar
			label: StringResources.get('card_sidebar_compare'),
			className: null
		};
	}

	isEnabled(cards) {
		if(cards.length !== 2) {
			return false;
		}

		const firstCardWidgets = this.layoutModel.listWidgets([cards[0].id]);
		const secondCardWidgets = this.layoutModel.listWidgets([cards[1].id]);

		return firstCardWidgets.length === 1 && secondCardWidgets.length === 1;
	}

	action(cards) {
		const newCompareCardId = this.layoutModel.addCompareCardFromExisting(cards[0], cards[1]);

		if (newCompareCardId) {
			this.exploreVM.setDisplayedToCard(newCompareCardId);
		}
	}
}

export { CompareAction };



// WEBPACK FOOTER //
// ./src/js/components/cards/actions/CompareAction.js